import {
   EMPLOYMENT_STATUS_OPTIONS,
   EMPLOYMENT_STATUS_REQUIRING_OCCUPATION_OPTIONS,
   TITLE_OPTIONS
} from "@constants/dropdown-choices";
import ObjetDataValidator from "@anjan011/object-data-validator";
import {transformValidationResultToArray} from "@utils/validation-markup-generator";
import {formatDate} from "date-fns";


export const ValidateStep1Data = (data) => {

    let nameMaxLen = 50;
    let nameAddressLen = 100;

    let titleValues = TITLE_OPTIONS?.map((item) => {
        return item.value
    });

    const rules = [
        {
            field_name: 'title',
            field_label: 'Title',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'in_array',
                    data: {
                        array: titleValues
                    },
                    message: 'Invalid title: {value}'
                }
            ]
        },
        {
            field_name: 'firstName',
            field_label: 'First name',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {
                        length: nameMaxLen
                    },
                    message: `First name cannot be longer than {length} characters`
                }
            ]
        },
        {
            field_name: 'lastName',
            field_label: 'Last name',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {
                    name: 'max_length',
                    data: {
                        length: nameMaxLen
                    },
                    message: `Last name cannot be longer than {length} characters`
                }
            ]
        },
        {
            field_name: 'birthDate',
            field_label: 'Birth date',
            rules: [
                {name: 'required'},
                {
                    name: 'date_string',
                    data: {
                        format: 'yyyy-MM-dd',
                    },
                    message: `Invalid birth date {value}`
                },
               {
                  name: 'date_string_before',
                  data: {
                     format: 'yyyy-MM-dd',
                     date : formatDate(new Date(), 'yyyy-MM-dd')
                  },
                  message: `Birth date must be before today's date`,
               },
            ]
        },
        
        {
            field_name: 'employmentStatus',
            field_label: 'Employment status',
            rules: [
                {name: 'required'},
                {name: 'string'},
                {name: 'max_length', data: {length: 50}},
                {
                    name: 'in_array', data: {
                        array: EMPLOYMENT_STATUS_OPTIONS?.map((item) => {
                            return item.value;
                        })
                    },
                    message: `Invalid employment status {value}`
                }
            ]

        },
      
        {
            field_name: 'mainOccupation',
            field_label: 'Main occupation',
            rules: [
                {
                    name: 'required_if_target_in_array',
                    data: {
                        target_field: 'employmentStatus',
                        array: EMPLOYMENT_STATUS_REQUIRING_OCCUPATION_OPTIONS
                    },
                    message : `Please provide your main occupation`
                },
                {name: 'string'},
                {name: 'max_length', data: {length: 100}}
            ]
        },
        {
            field_name: 'occupationIndustry',
            field_label: 'Occupation industry',
            rules: [
                {
                    name: 'required_if_target_in_array',
                    data: {
                        target_field: 'employmentStatus',
                        array: EMPLOYMENT_STATUS_REQUIRING_OCCUPATION_OPTIONS
                    },
                    message : `Please provide your occupation industry`
                },
                {name: 'string'},
                {name: 'max_length', data: {length: 100}}
            ]
        }
    ];

    const validator = new ObjetDataValidator({
        data,
        rules
    });

    const result = validator.validate();

    if (result === true) {
        return [];
    } else {
        return transformValidationResultToArray(result);
    }

}